module.exports = __webpack_public_path__ + "img/slv.1176ea28.svg";